const countryList = [
	{value: "FR" , label: "France"},
	{value: "AD" , label: "Andorre"},
	{value: "AE" , label: "Émirats Arabes Unis"},
	{value: "AF" , label: "Afghanistan"},
	{value: "AG" , label: "Antigua-Et-Barbuda"},
	{value: "AI" , label: "Anguilla"},
	{value: "AL" , label: "Albanie"},
	{value: "AM" , label: "Arménie"},
	{value: "AO" , label: "Angola"},
	{value: "AP" , label: "Région Asie/Pacifique"},
	{value: "AQ" , label: "Antarctique"},
	{value: "AR" , label: "Argentine"},
	{value: "AS" , label: "Samoa Américaines"},
	{value: "AT" , label: "Autriche"},
	{value: "AU" , label: "Australie"},
	{value: "AW" , label: "Aruba"},
	{value: "AX" , label: "Îles Åland"},
	{value: "AZ" , label: "Azerbaïdjan"},
	{value: "BA" , label: "Bosnie-Herzégovine"},
	{value: "BB" , label: "Barbad"},
	{value: "BD" , label: "Bangladesh"},
	{value: "BE" , label: "Belgique"},
	{value: "BF" , label: "Burkina Faso"},
	{value: "BG" , label: "Bulgarie"},
	{value: "BH" , label: "Bahreïn"},
	{value: "BI" , label: "Burundi"},
	{value: "BJ" , label: "Bénin"},
	{value: "BL" , label: "Saint-Barthélemy"},
	{value: "BM" , label: "Bermudes"},
	{value: "BN" , label: "Brunei Darussalam"},
	{value: "BO" , label: "État Plurinational De Bolivie"},
	{value: "BQ" , label: "Bonaire, Saint-Eustache Et Saba"},
	{value: "BR" , label: "Brésil"},
	{value: "BS" , label: "Bahamas"},
	{value: "BT" , label: "Bhoutan"},
	{value: "BV" , label: "Île Bouvet"},
	{value: "BW" , label: "Botswana"},
	{value: "BY" , label: "Biélorussie"},
	{value: "BZ" , label: "Belize"},
	{value: "CA" , label: "Canada"},
	{value: "CC" , label: "Îles Cocos"},
	{value: "CD" , label: "République Démocratique Du Congo"},
	{value: "CF" , label: "République Centrafricaine"},
	{value: "CG" , label: "Congo"},
	{value: "CH" , label: "Suisse"},
	{value: "CI" , label: "Côte D'Ivoire"},
	{value: "CK" , label: "Îles Cook"},
	{value: "CL" , label: "Chili"},
	{value: "CM" , label: "Cameroun"},
	{value: "CN" , label: "Chine"},
	{value: "CO" , label: "Colombie"},
	{value: "CR" , label: "Costa Rica"},
	{value: "CU" , label: "Cuba"},
	{value: "CV" , label: "Cap-Vert"},
	{value: "CW" , label: "Curaçao"},
	{value: "CX" , label: "Île Christmas"},
	{value: "CY" , label: "Chypre"},
	{value: "CZ" , label: "République Tchèque"},
	{value: "DE" , label: "Allemagne"},
	{value: "DJ" , label: "Djibouti"},
	{value: "DK" , label: "Denmark"},
	{value: "DM" , label: "Dominique"},
	{value: "DO" , label: "République Dominicaine"},
	{value: "DZ" , label: "Algérie"},
	{value: "EC" , label: "Équateur"},
	{value: "EE" , label: "Estonie"},
	{value: "EG" , label: "Égypte"},
	{value: "EH" , label: "Sahara Occidental"},
	{value: "ER" , label: "Érythrée"},
	{value: "ES" , label: "Espagne"},
	{value: "ET" , label: "Éthiopie"},
	{value: "EU" , label: "Europe"},
	{value: "FI" , label: "Finlande"},
	{value: "FJ" , label: "Fidji"},
	{value: "FK" , label: "Îles Malouines"},
	{value: "FM" , label: "États Fédérés De Micronésie"},
	{value: "FO" , label: "Îles Féroé"},
	{value: "GA" , label: "Gabon"},
	{value: "GB" , label: "Royaume-Uni"},
	{value: "GD" , label: "Grenade"},
	{value: "GE" , label: "Géorgie"},
	{value: "GF" , label: "Guyane"},
	{value: "GG" , label: "Guernesey"},
	{value: "GH" , label: "Ghana"},
	{value: "GI" , label: "Gibraltar"},
	{value: "GL" , label: "Groenland"},
	{value: "GM" , label: "Gambie"},
	{value: "GN" , label: "Guinée"},
	{value: "GP" , label: "Guadeloupe"},
	{value: "GQ" , label: "Guinée Équatoriale"},
	{value: "GR" , label: "Grèce"},
	{value: "GS" , label: "Géorgie Du Sud-Et-Les Îles Sandwich Du Sud"},
	{value: "GT" , label: "Guatemala"},
	{value: "GU" , label: "Guam"},
	{value: "GW" , label: "Guinée-Bissau"},
	{value: "GY" , label: "Guyana"},
	{value: "HK" , label: "Hong Kong"},
	{value: "HM" , label: "Îles Heard-Et-MacDonald"},
	{value: "HN" , label: "Honduras"},
	{value: "HR" , label: "Croatie"},
	{value: "HT" , label: "Haïti"},
	{value: "HU" , label: "Hongrie"},
	{value: "ID" , label: "Indonésie"},
	{value: "IE" , label: "Irlande"},
	{value: "IL" , label: "Israël"},
	{value: "IM" , label: "Île De Man"},
	{value: "IN" , label: "Inde"},
	{value: "IO" , label: "Territoire Britannique De L'océan Indien"},
	{value: "IQ" , label: "Irak"},
	{value: "IR" , label: "République Islamique D'Iran"},
	{value: "IS" , label: "Islande"},
	{value: "IT" , label: "Italie"},
	{value: "JE" , label: "Jersey"},
	{value: "JM" , label: "Jamaïque"},
	{value: "JO" , label: "Jordanie"},
	{value: "JP" , label: "Japon"},
	{value: "KE" , label: "Kenya"},
	{value: "KG" , label: "Kirghizistan"},
	{value: "KH" , label: "Cambodge"},
	{value: "KI" , label: "Kiribati"},
	{value: "KM" , label: "Comores"},
	{value: "KN" , label: "Saint-Christophe-et-Niévès"},
	{value: "KP" , label: "République Populaire Démocratique De Corée"},
	{value: "KR" , label: "République De Corée"},
	{value: "KW" , label: "Koweït"},
	{value: "KY" , label: "Îles Caïmans"},
	{value: "KZ" , label: "Kazakhstan"},
	{value: "LA" , label: "République Démocratique Populaire Lao"},
	{value: "LB" , label: "Liban"},
	{value: "LC" , label: "Sainte-Lucie"},
	{value: "LI" , label: "Liechtenstein"},
	{value: "LK" , label: "Sri Lanka"},
	{value: "LR" , label: "Liberia"},
	{value: "LS" , label: "Lesotho"},
	{value: "LT" , label: "Lituanie"},
	{value: "LU" , label: "Luxembourg"},
	{value: "LV" , label: "Lettonie"},
	{value: "LY" , label: "Libye"},
	{value: "MA" , label: "Maroc"},
	{value: "MC" , label: "Monaco"},
	{value: "MD" , label: "République De Moldavie"},
	{value: "ME" , label: "Monténégro"},
	{value: "MF" , label: "Saint-Martin (Partie Française)"},
	{value: "MG" , label: "Madagascar"},
	{value: "MH" , label: "Îles Marshall"},
	{value: "MK" , label: "Macédoine"},
	{value: "ML" , label: "Mali"},
	{value: "MM" , label: "Birmanie"},
	{value: "MN" , label: "Mongolie"},
	{value: "MO" , label: "Macao"},
	{value: "MP" , label: "Îles Mariannes Du Nord"},
	{value: "MQ" , label: "Martinique"},
	{value: "MR" , label: "Mauritanie"},
	{value: "MS" , label: "Montserrat"},
	{value: "MT" , label: "Malte"},
	{value: "MU" , label: "Maurice"},
	{value: "MV" , label: "Maldives"},
	{value: "MW" , label: "Malawi"},
	{value: "MX" , label: "Mexique"},
	{value: "MY" , label: "Malaisie"},
	{value: "MZ" , label: "Mozambique"},
	{value: "NA" , label: "Namibie"},
	{value: "NC" , label: "Nouvelle-Calédonie"},
	{value: "NE" , label: "Niger"},
	{value: "NF" , label: "Île Norfolk"},
	{value: "NG" , label: "Nigéria"},
	{value: "NI" , label: "Nicaragua"},
	{value: "NL" , label: "Pays-Bas"},
	{value: "NO" , label: "Norvège"},
	{value: "NP" , label: "Népal"},
	{value: "NR" , label: "Nauru"},
	{value: "NU" , label: "Niue"},
	{value: "NZ" , label: "Nouvelle-Zélande"},
	{value: "OM" , label: "Oman"},
	{value: "PA" , label: "Panama"},
	{value: "PE" , label: "Pérou"},
	{value: "PF" , label: "Polynésie Française"},
	{value: "PG" , label: "Papouasie-Nouvelle-Guinée"},
	{value: "PH" , label: "Philippines"},
	{value: "PK" , label: "Pakistan"},
	{value: "PL" , label: "Pologne"},
	{value: "PM" , label: "Saint-Pierre-Et-Miquelon"},
	{value: "PN" , label: "Pitcairn"},
	{value: "PR" , label: "Porto Rico"},
	{value: "PS" , label: "Territoires Palestiniens Occupés"},
	{value: "PT" , label: "Portugal"},
	{value: "PW" , label: "Palaos"},
	{value: "PY" , label: "Paraguay"},
	{value: "QA" , label: "Qatar"},
	{value: "RE" , label: "Réunion"},
	{value: "RO" , label: "Roumanie"},
	{value: "RS" , label: "Serbie"},
	{value: "RU" , label: "Fédération De Russie"},
	{value: "RW" , label: "Rwanda"},
	{value: "SA" , label: "Arabie Saoudite"},
	{value: "SB" , label: "Îles Salomon"},
	{value: "SC" , label: "Seychelles"},
	{value: "SD" , label: "Soudan"},
	{value: "SE" , label: "Suède"},
	{value: "SG" , label: "Singapour"},
	{value: "SH" , label: "Sainte-Hélène"},
	{value: "SI" , label: "Slovénie"},
	{value: "SJ" , label: "Svalbard Et Jan Mayen"},
	{value: "SK" , label: "Slovaquie"},
	{value: "SL" , label: "Sierra Leone"},
	{value: "SM" , label: "Saint-Marin"},
	{value: "SN" , label: "Sénégal"},
	{value: "SO" , label: "Somalie"},
	{value: "SR" , label: "Suriname"},
	{value: "SS" , label: "Soudan Du Sud"},
	{value: "ST" , label: "Sao Tomé-Et-Principe"},
	{value: "SV" , label: "République Du Salvador"},
	{value: "SX" , label: "Saint-Martin (Partie Néerlandaise)"},
	{value: "SY" , label: "République Arabe Syrienne"},
	{value: "SZ" , label: "Swaziland"},
	{value: "TC" , label: "Îles Turks-Et-Caïcos"},
	{value: "TD" , label: "Tchad"},
	{value: "TF" , label: "Terres Australes Françaises"},
	{value: "TG" , label: "Togo"},
	{value: "TH" , label: "Thaïlande"},
	{value: "TJ" , label: "Tadjikistan"},
	{value: "TK" , label: "Tokelau"},
	{value: "TL" , label: "Timor-Leste"},
	{value: "TM" , label: "Turkménistan"},
	{value: "TN" , label: "Tunisie"},
	{value: "TO" , label: "Tonga"},
	{value: "TR" , label: "Turquie"},
	{value: "TT" , label: "Trinité-Et-Tobago"},
	{value: "TV" , label: "Tuvalu"},
	{value: "TW" , label: "Taïwan"},
	{value: "TZ" , label: "République-Unie De Tanzanie"},
	{value: "UA" , label: "Ukraine"},
	{value: "UG" , label: "Ouganda"},
	{value: "UM" , label: "Îles Mineures Éloignées Des États-Unis"},
	{value: "US" , label: "États-Unis"},
	{value: "UY" , label: "Uruguay"},
	{value: "UZ" , label: "Ouzbékistan"},
	{value: "VA" , label: "Saint-Siège (État De La Cité Du Vatican)"},
	{value: "VC" , label: "Saint-Vincent-Et-Les Grenadines"},
	{value: "VE" , label: "Venezuela"},
	{value: "VG" , label: "Îles Vierges Britanniques"},
	{value: "VI" , label: "Îles Vierges Des États-Unis"},
	{value: "VN" , label: "Viet Nam"},
	{value: "VU" , label: "Vanuatu"},
	{value: "WF" , label: "Wallis Et Futuna"},
	{value: "WS" , label: "Samoa"},
	{value: "YE" , label: "Yémen"},
	{value: "YT" , label: "Mayotte"},
	{value: "ZA" , label: "Afrique Du Sud"},
	{value: "ZM" , label: "Zambie"},
	{value: "ZW" , label: "Zimbabwe"},
]

export default countryList;